import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from './store'

export interface AppState {
    state: 'begin' | 'sendingOrder' | 'sendingOrderComplete' | 'sendingOrderError'
}

const initialState: AppState = {
    state: 'begin'
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        sendingOrderComplete: (state) => {
            if (state.state !== 'sendingOrder') {
                console.error('sendingOrderComplete called when state is not sendingOrder')
                throw new Error('sendingOrderComplete called when state is not sendingOrder')
            }

             state.state = 'sendingOrderComplete'
        },
        startSendingOrder: (state) => {
            if (state.state !== 'begin' && state.state !== 'sendingOrderError') {
                console.error('startSendingOrder called when state is not begin or sendingOrderError')
                throw new Error('startSendingOrder called when state is not begin or sendingOrderError')
            }

            state.state = 'sendingOrder'
        }
    },
  })
  
export const { startSendingOrder, sendingOrderComplete } = appSlice.actions
export default appSlice.reducer
export const selectState = (state: RootState) => state.app.state